import React from 'react'

import { ZariContext } from '_zari/context'
import { Modal, Button, Form, Col, Row } from '_zari/core'

import * as AlmacenService from 'services/almacen.service'
import * as SedeService from 'services/sede.service'

const ModalAlmacen = ({ show, handleClose, onCreado }) => {
  const __zariContext = React.useContext(ZariContext)

  const [sedes, setSedes] = React.useState([])
  const [_idSede, setIdSede] = React.useState('')
  const [nombre, setNombre] = React.useState('')
  const [descripcion, setDescripcion] = React.useState('')
  const [guardando, setGuardando] = React.useState(false)

  React.useEffect(() => {
    SedeService.obtenerAsSelect()
      .then(({ data }) => {
        setSedes(data || [])
        if (data && data.length === 1) setIdSede(data[0]._id)
      })
      .catch(() => setSedes([]))
  }, [])

  const guardar = async () => {
    if (!_idSede) {
      __zariContext.snack('error', 'Seleccione una sede')
      return
    }
    if (!nombre.trim()) {
      __zariContext.snack('error', 'Ingrese el nombre del almacén')
      return
    }
    setGuardando(true)
    try {
      const { data } = await AlmacenService.nuevoAlmacen({
        _idSede,
        nombre: nombre.trim(),
        descripcion: descripcion.trim()
      })
      __zariContext.snack('success', 'Almacén creado')
      onCreado && onCreado(data)
    } catch (err) {
      __zariContext.snack('error', err?.data?.error || 'Error al crear el almacén')
    } finally {
      setGuardando(false)
    }
  }

  return (
    <Modal show={show} size='md'>
      <Modal.Header>
        <Modal.Title>
          <i className='fa fa-warehouse mr-2' style={{ color: '#1F3A8A' }} />
          Nuevo Almacén
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={12}>
            <Form.Group>
              <Form.Label text='SEDE *' md={12} />
              <Col md={12}>
                <Form.Select
                  value={_idSede}
                  onChange={(e) => setIdSede(e.target.value)}
                  disabled={guardando}
                  id='select-sede-alm'
                >
                  <option value=''>Seleccionar</option>
                  {sedes.map((s) => (
                    <option key={s._id} value={s._id}>
                      {s.nombre}
                    </option>
                  ))}
                </Form.Select>
              </Col>
            </Form.Group>

            <Form.Group>
              <Form.Label text='NOMBRE *' md={12} />
              <Col md={12}>
                <Form.InputText
                  value={nombre}
                  onChange={(e) => setNombre(e.target.value)}
                  placeholder='Ej: Almacén Central'
                  disabled={guardando}
                  id='input-nombre-alm'
                />
              </Col>
            </Form.Group>

            <Form.Group>
              <Form.Label text='DESCRIPCIÓN' md={12} />
              <Col md={12}>
                <Form.InputText
                  value={descripcion}
                  onChange={(e) => setDescripcion(e.target.value)}
                  placeholder='(opcional)'
                  disabled={guardando}
                  id='input-desc-alm'
                />
              </Col>
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose} disabled={guardando}>
          Cancelar
        </Button>
        <Button onClick={guardar} disabled={guardando}>
          <i className='fa fa-check mr-1' />
          Crear
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalAlmacen
